module.exports = __webpack_public_path__ + "img/placeholder-port.50ba5025.svg";